import React from 'react';
import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import BoldIcon from '../../../../assets/icons/BoldIcon';
import ItalicIcon from '../../../../assets/icons/ItalicIcon';
import {WHATSAPP_MAX_TEXT_LENGTH} from '../../../../pages/branding/whatsAppScreen/whatsAppValidation';
import * as css from './WhatsAppEditorFooter.css';

interface WhatsAppEditorFooterProps {
    hasChanged: boolean;
    saveDisabled: boolean;
    totalCharacters: number;
    isCharCountExceeded: boolean;
    onFormat: (command: string) => void;
    onSave: () => void;
}

function WhatsAppEditorFooter({
    hasChanged,
    saveDisabled,
    totalCharacters,
    isCharCountExceeded,
    onFormat,
    onSave
}: WhatsAppEditorFooterProps) {
    const {t} = useTranslation('branding');

    return (
        <css.footer>
            <css.formattingToolbar>
                <Button
                    variant="primary"
                    onClick={() => onFormat('bold')}
                    title="Bold"
                    iconStart={<BoldIcon />}
                />
                <Button
                    variant="primary"
                    onClick={() => onFormat('italic')}
                    title="Italic"
                    iconStart={<ItalicIcon />}
                />
                <css.charCounter isExceeded={isCharCountExceeded}>
                    {totalCharacters}/{WHATSAPP_MAX_TEXT_LENGTH}
                </css.charCounter>
            </css.formattingToolbar>
            {onSave && (
                <Button
                    variant="brand"
                    disabled={!hasChanged || saveDisabled}
                    onClick={onSave}
                    title="Save"
                    size='category'
                >
                    {t('save')}
                </Button>
            )}
        </css.footer>
    );
}

export default WhatsAppEditorFooter;
